<template>
  <div class="socials">
    <a v-for="(item, i) in socials" :key="i" :href="item.link" target="_blank">
      <figure class="file-icon" v-html="item.value"></figure>
    </a>
  </div>
</template>

<script>
export default {
  name: "SocialsComponent",
  computed: {
    socials() {
      if (
        this.$store.state.marketplace &&
        this.$store.state.marketplace.communications &&
        this.$store.state.marketplace.communications.length
      ) {
        return this.$store.state.marketplace?.communications.filter(
          (item) => this.$store.state._types.SOCIAL === item.type.code
        );
      }
      return [];
    },
  },
};
</script>

<style lang="stylus">
.socials {
  display flex
  align-items center
  gap 5px
  justify-content flex-start

  a {
    display flex
    align-items center
    justify-content center
    width 40px
    height 40px
    border-radius 50%
    border 1px solid var(--gray)
    background var(--white)

    &:hover {
      background var(--gray-2-dark)
    }

    .file-icon {
      width 20px
      height 20px
    }
  }
}
</style>
